export const SERVICE_DOMAINS = {
    API: 'https://apidev.spotter.bot'
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/constants/services.ts